import { VizState } from '@cubejs-client/react';
import { Chart } from '@threatadvisor/react-components';
import { Typography } from 'antd';
import React, { ReactElement, useState } from 'react';

type StatusReportParams = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function EventsByTechnique(props: StatusReportParams): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const chartConfig: VizState = {
    chartType: 'bar',
    pivotConfig: {
      x: ['security_event_mapping.technique'],
      y: ['measures'],
      fillMissingDates: true
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event_mapping.technique'],
      timeDimensions: [
        {
          dimension: 'security_event.createdDate',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ],
      limit: 15
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Events by Technique</h2>
      <figure>
        {' '}
        <Chart
          hideCubeName
          useGridTable
          useHeightBasedOnHowManyItems
          chartConfig={{
            legend: false
          }}
          config={chartConfig}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows MITRE ATT&CK Technique associated with events received. See Appendix A for
            additional information.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
